var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
const PlayerComponent = ({ options, onReady }) => {
    _react_refresh_temp_2();
    const videoRef = React.useRef(null);
    const [player, setPlayer] = useState();
    useEffect(() => {
        const videoElement = videoRef.current;
        if (videoElement && !player) {
            const player = videojs(videoElement, options, () => {
                onReady && onReady(player);
            });
            setPlayer(player);
        }
    }, [videoRef]);
    // Dispose the Video.js player when the functional component unmounts
    useEffect(() => {
        return () => {
            if (player) {
                player.dispose();
                setPlayer(undefined);
            }
        };
    }, [player]);
    return (_jsx("div", { className: "react-js-player-wrap", children: _jsx("div", { "data-vjs-player": true, children: _jsx("video", { ref: videoRef, className: "video-js" }) }) }));
};
_react_refresh_temp_1 = PlayerComponent;
$RefreshReg$(_react_refresh_temp_1, "PlayerComponent");
_react_refresh_temp_2(PlayerComponent, "crYwlPUfeaSra8kCfOY+bYKa1oo=");
export default PlayerComponent;
